(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[52615,22746,62909],{

/***/ 635412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Dropdown; }
/* harmony export */ });
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82389);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(281668);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Dropdown = (_a) => {
  var _b = _a, {
    children,
    menu,
    placement = "auto",
    showArrow = false,
    trigger = "hover"
  } = _b, rest = __objRest(_b, [
    "children",
    "menu",
    "placement",
    "showArrow",
    "trigger"
  ]);
  const [show, setShow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const tooltipRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const arrowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!show) {
      return;
    }
    function handleClickOutside(event) {
      if (elementRef.current && !elementRef.current.contains(event.target)) {
        setShow(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [elementRef, show]);
  const { styles, attributes } = (0,react_popper__WEBPACK_IMPORTED_MODULE_1__/* .usePopper */ .D)(elementRef.current, tooltipRef.current, {
    placement,
    modifiers: [
      {
        name: "arrow",
        options: { element: arrowRef.current }
      },
      {
        name: "offset",
        options: {
          offset: [0, 4]
        }
      }
    ]
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    onMouseEnter: () => trigger === "hover" && setShow(true),
    onClick: () => {
      trigger === "click" && setShow(!show);
    },
    onMouseLeave: () => trigger === "hover" && setShow(false)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: elementRef
  }, children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownMenu, __spreadValues(__spreadValues({
    show,
    ref: tooltipRef,
    style: __spreadProps(__spreadValues({}, styles.popper), { zIndex: 100 })
  }, attributes.popper), rest), showArrow && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledArrow, {
    ref: arrowRef,
    style: __spreadValues({}, styles.arrow),
    "data-placement": placement,
    className: (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .getArrowClassName */ .C)(attributes) || ""
  }), menu));
};
const DropdownMenu = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].span`
  background-color: white;
  padding: 4px;
  border-radius: 4px;
  visibility: ${(props) => props.show ? "visible" : "hidden"};
  transition: visibility 0.3s;
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const StyledArrow = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  &:after {
    content: '';
    position: absolute;
    width: 6px;
    height: 6px;
    background-color: white;
    transform: rotate(45deg);
  }
  &.arrow-bottom {
    bottom: 3px;
  }
  &.arrow-top {
    top: -3px;
  }
  &.arrow-left {
    left: -3px;
  }
  &.arrow-right {
    right: 3px;
  }
`;




/***/ }),

/***/ 751707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ ChevronLeftFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ChevronLeftFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 512 512", fill: "none" },
    child: [
      {
        tag: "polyline",
        attr: {
          points: "328 112 184 256 328 400",
          strokeWidth: "48px",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "currentColor"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 753954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ ClockAlternativeOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ClockAlternativeOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.4924 14.25C16.9066 14.2541 17.2458 13.9218 17.25 13.5076C17.2541 13.0934 16.9218 12.7542 16.5076 12.75L13.9874 12.7246C13.302 12.7177 12.75 12.1601 12.75 11.4746V8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V11.4746C11.25 12.9826 12.4644 14.2093 13.9722 14.2245L16.4924 14.25Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 622746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ForwardOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ForwardOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.5 19L15.5 12L8.5 5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 792446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ HomePageOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const HomePageOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15.414 6.04594L10.3573 0.988608C9.7315 0.364601 8.88378 0.0141907 8.00001 0.0141907C7.11623 0.0141907 6.26851 0.364601 5.64267 0.988608L0.586008 6.04594C0.399625 6.23113 0.251855 6.45147 0.151263 6.6942C0.0506715 6.93692 -0.000740267 7.1972 8.05299e-06 7.45994V14.0046C8.05299e-06 14.535 0.210722 15.0437 0.585795 15.4188C0.960867 15.7939 1.46958 16.0046 2.00001 16.0046H14C14.5304 16.0046 15.0391 15.7939 15.4142 15.4188C15.7893 15.0437 16 14.535 16 14.0046V7.45994C16.0008 7.1972 15.9493 6.93692 15.8488 6.6942C15.7482 6.45147 15.6004 6.23113 15.414 6.04594ZM10 14.6713H6.00001V12.0486C6.00001 11.5182 6.21072 11.0095 6.58579 10.6344C6.96087 10.2593 7.46958 10.0486 8.00001 10.0486C8.53044 10.0486 9.03915 10.2593 9.41422 10.6344C9.7893 11.0095 10 11.5182 10 12.0486V14.6713ZM14.6667 14.0046C14.6667 14.1814 14.5964 14.351 14.4714 14.476C14.3464 14.601 14.1768 14.6713 14 14.6713H11.3333V12.0486C11.3333 11.1646 10.9822 10.3167 10.357 9.69159C9.73191 9.06646 8.88406 8.71527 8.00001 8.71527C7.11595 8.71527 6.26811 9.06646 5.64299 9.69159C5.01786 10.3167 4.66667 11.1646 4.66667 12.0486V14.6713H2.00001C1.8232 14.6713 1.65363 14.601 1.5286 14.476C1.40358 14.351 1.33334 14.1814 1.33334 14.0046V7.45994C1.33396 7.28326 1.40413 7.11393 1.52867 6.98861L6.58534 1.93327C6.96114 1.55923 7.46979 1.34924 8.00001 1.34924C8.53023 1.34924 9.03888 1.55923 9.41467 1.93327L14.4713 6.99061C14.5954 7.11544 14.6655 7.28395 14.6667 7.45994V14.0046Z",
          fill: "black"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 615819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ HomepageAlternativeOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const HomepageAlternativeOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M3 10.714L12 3L21 10.714",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M4 10V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V10",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9.4292 21V16.571C9.4292 16.0406 9.63991 15.5319 10.015 15.1568C10.3901 14.7818 10.8988 14.571 11.4292 14.571H12.5722C13.1026 14.571 13.6113 14.7818 13.9864 15.1568C14.3615 15.5319 14.5722 16.0406 14.5722 16.571V21",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 33188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ MoreInforOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const MoreInforOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM6 10C7.10457 10 8 10.8954 8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10ZM18 10C19.1046 10 20 10.8954 20 12C20 13.1046 19.1046 14 18 14C16.8954 14 16 13.1046 16 12C16 10.8954 16.8954 10 18 10Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 933104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ MoreProductOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const MoreProductOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4 3.5H9C9.27614 3.5 9.5 3.72386 9.5 4V9C9.5 9.27614 9.27614 9.5 9 9.5H4C3.72386 9.5 3.5 9.27614 3.5 9V4C3.5 3.72386 3.72386 3.5 4 3.5ZM2 4C2 2.89543 2.89543 2 4 2H9C10.1046 2 11 2.89543 11 4V9C11 10.1046 10.1046 11 9 11H4C2.89543 11 2 10.1046 2 9V4ZM4 14.5H9C9.27614 14.5 9.5 14.7239 9.5 15V20C9.5 20.2761 9.27614 20.5 9 20.5H4C3.72386 20.5 3.5 20.2761 3.5 20V15C3.5 14.7239 3.72386 14.5 4 14.5ZM2 15C2 13.8954 2.89543 13 4 13H9C10.1046 13 11 13.8954 11 15V20C11 21.1046 10.1046 22 9 22H4C2.89543 22 2 21.1046 2 20V15ZM20 3.5H15C14.7239 3.5 14.5 3.72386 14.5 4V9C14.5 9.27614 14.7239 9.5 15 9.5H20C20.2761 9.5 20.5 9.27614 20.5 9V4C20.5 3.72386 20.2761 3.5 20 3.5ZM15 2C13.8954 2 13 2.89543 13 4V9C13 10.1046 13.8954 11 15 11H20C21.1046 11 22 10.1046 22 9V4C22 2.89543 21.1046 2 20 2H15ZM15 14.5H20C20.2761 14.5 20.5 14.7239 20.5 15V20C20.5 20.2761 20.2761 20.5 20 20.5H15C14.7239 20.5 14.5 20.2761 14.5 20V15C14.5 14.7239 14.7239 14.5 15 14.5ZM13 15C13 13.8954 13.8954 13 15 13H20C21.1046 13 22 13.8954 22 15V20C22 21.1046 21.1046 22 20 22H15C13.8954 22 13 21.1046 13 20V15Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 803537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ NewMoreProductOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const NewMoreProductOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_2774_2758)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M4.66667 0H2.66667C1.95942 0 1.28115 0.280952 0.781049 0.781049C0.280952 1.28115 0 1.95942 0 2.66667L0 4.66667C0 5.37391 0.280952 6.05219 0.781049 6.55229C1.28115 7.05238 1.95942 7.33333 2.66667 7.33333H4.66667C5.37391 7.33333 6.05219 7.05238 6.55229 6.55229C7.05238 6.05219 7.33333 5.37391 7.33333 4.66667V2.66667C7.33333 1.95942 7.05238 1.28115 6.55229 0.781049C6.05219 0.280952 5.37391 0 4.66667 0V0ZM6 4.66667C6 5.02029 5.85952 5.35943 5.60948 5.60948C5.35943 5.85952 5.02029 6 4.66667 6H2.66667C2.31304 6 1.97391 5.85952 1.72386 5.60948C1.47381 5.35943 1.33333 5.02029 1.33333 4.66667V2.66667C1.33333 2.31304 1.47381 1.97391 1.72386 1.72386C1.97391 1.47381 2.31304 1.33333 2.66667 1.33333H4.66667C5.02029 1.33333 5.35943 1.47381 5.60948 1.72386C5.85952 1.97391 6 2.31304 6 2.66667V4.66667Z",
              fill: "black"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M13.3332 0H11.3332C10.6259 0 9.94765 0.280952 9.44755 0.781049C8.94745 1.28115 8.6665 1.95942 8.6665 2.66667V4.66667C8.6665 5.37391 8.94745 6.05219 9.44755 6.55229C9.94765 7.05239 10.6259 7.33334 11.3332 7.33334H13.3332C14.0404 7.33334 14.7187 7.05239 15.2188 6.55229C15.7189 6.05219 15.9998 5.37391 15.9998 4.66667V2.66667C15.9998 1.95942 15.7189 1.28115 15.2188 0.781049C14.7187 0.280952 14.0404 0 13.3332 0V0ZM14.6665 4.66667C14.6665 5.02029 14.526 5.35943 14.276 5.60948C14.0259 5.85953 13.6868 6 13.3332 6H11.3332C10.9795 6 10.6404 5.85953 10.3904 5.60948C10.1403 5.35943 9.99984 5.02029 9.99984 4.66667V2.66667C9.99984 2.31305 10.1403 1.97391 10.3904 1.72386C10.6404 1.47381 10.9795 1.33333 11.3332 1.33333H13.3332C13.6868 1.33333 14.0259 1.47381 14.276 1.72386C14.526 1.97391 14.6665 2.31305 14.6665 2.66667V4.66667Z",
              fill: "black"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M4.66667 8.66667H2.66667C1.95942 8.66667 1.28115 8.94762 0.781049 9.44772C0.280952 9.94782 0 10.6261 0 11.3333L0 13.3333C0 14.0406 0.280952 14.7189 0.781049 15.219C1.28115 15.7191 1.95942 16 2.66667 16H4.66667C5.37391 16 6.05219 15.7191 6.55229 15.219C7.05238 14.7189 7.33333 14.0406 7.33333 13.3333V11.3333C7.33333 10.6261 7.05238 9.94782 6.55229 9.44772C6.05219 8.94762 5.37391 8.66667 4.66667 8.66667ZM6 13.3333C6 13.687 5.85952 14.0261 5.60948 14.2762C5.35943 14.5262 5.02029 14.6667 4.66667 14.6667H2.66667C2.31304 14.6667 1.97391 14.5262 1.72386 14.2762C1.47381 14.0261 1.33333 13.687 1.33333 13.3333V11.3333C1.33333 10.9797 1.47381 10.6406 1.72386 10.3905C1.97391 10.1405 2.31304 10 2.66667 10H4.66667C5.02029 10 5.35943 10.1405 5.60948 10.3905C5.85952 10.6406 6 10.9797 6 11.3333V13.3333Z",
              fill: "black"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M13.3332 8.66667H11.3332C10.6259 8.66667 9.94765 8.94762 9.44755 9.44772C8.94745 9.94782 8.6665 10.6261 8.6665 11.3333V13.3333C8.6665 14.0406 8.94745 14.7189 9.44755 15.219C9.94765 15.7191 10.6259 16 11.3332 16H13.3332C14.0404 16 14.7187 15.7191 15.2188 15.219C15.7189 14.7189 15.9998 14.0406 15.9998 13.3333V11.3333C15.9998 10.6261 15.7189 9.94782 15.2188 9.44772C14.7187 8.94762 14.0404 8.66667 13.3332 8.66667ZM14.6665 13.3333C14.6665 13.687 14.526 14.0261 14.276 14.2762C14.0259 14.5262 13.6868 14.6667 13.3332 14.6667H11.3332C10.9795 14.6667 10.6404 14.5262 10.3904 14.2762C10.1403 14.0261 9.99984 13.687 9.99984 13.3333V11.3333C9.99984 10.9797 10.1403 10.6406 10.3904 10.3905C10.6404 10.1405 10.9795 10 11.3332 10H13.3332C13.6868 10 14.0259 10.1405 14.276 10.3905C14.526 10.6406 14.6665 10.9797 14.6665 11.3333V13.3333Z",
              fill: "black"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_2774_2758" },
            child: [
              {
                tag: "rect",
                attr: { width: "16", height: "16", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 247693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ NewSearchOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const NewSearchOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15.8045 14.8625L11.8252 10.8831C12.9096 9.55686 13.4428 7.86453 13.3144 6.15617C13.1861 4.44782 12.406 2.85415 11.1356 1.70481C9.86516 0.555472 8.20158 -0.0616068 6.48895 -0.0187856C4.77632 0.0240356 3.14566 0.723481 1.93426 1.93487C0.72287 3.14627 0.0234252 4.77693 -0.019396 6.48956C-0.0622172 8.20219 0.554862 9.86577 1.7042 11.1362C2.85354 12.4066 4.44721 13.1867 6.15556 13.315C7.86392 13.4434 9.55625 12.9102 10.8825 11.8258L14.8619 15.8051C14.9876 15.9266 15.156 15.9938 15.3308 15.9922C15.5056 15.9907 15.6728 15.9206 15.7964 15.797C15.92 15.6734 15.9901 15.5062 15.9916 15.3314C15.9932 15.1566 15.926 14.9882 15.8045 14.8625ZM6.66652 12.0005C5.61169 12.0005 4.58054 11.6877 3.70348 11.1016C2.82642 10.5156 2.14283 9.68265 1.73916 8.70811C1.3355 7.73357 1.22988 6.66122 1.43567 5.62665C1.64145 4.59208 2.14941 3.64178 2.89529 2.8959C3.64117 2.15002 4.59147 1.64206 5.62604 1.43628C6.6606 1.23049 7.73296 1.33611 8.7075 1.73977C9.68204 2.14344 10.515 2.82703 11.101 3.70409C11.6871 4.58115 11.9999 5.6123 11.9999 6.66713C11.9983 8.08113 11.4359 9.43676 10.436 10.4366C9.43615 11.4365 8.08052 11.9989 6.66652 12.0005Z",
          fill: "black"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 734104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ TimeForwardOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const TimeForwardOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_2753_2749)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M15.3331 7.33333C15.1563 7.33333 14.9868 7.40357 14.8617 7.5286C14.7367 7.65362 14.6665 7.82319 14.6665 8C14.6719 9.55018 14.1388 11.0541 13.1582 12.2548C12.1776 13.4554 10.8104 14.2782 9.29041 14.5825C7.77038 14.8869 6.19184 14.6538 4.82461 13.9232C3.45737 13.1927 2.38631 12.0099 1.7945 10.5771C1.2027 9.14433 1.12689 7.55049 1.58003 6.06801C2.03317 4.58552 2.98713 3.30644 4.27885 2.44938C5.57057 1.59232 7.11986 1.2105 8.66191 1.36918C10.204 1.52786 11.643 2.21718 12.7331 3.31933C12.7112 3.32531 12.689 3.32999 12.6665 3.33333H10.6665C10.4897 3.33333 10.3201 3.40357 10.1951 3.5286C10.0701 3.65362 9.99982 3.82319 9.99982 4C9.99982 4.17681 10.0701 4.34638 10.1951 4.47141C10.3201 4.59643 10.4897 4.66667 10.6665 4.66667H12.6665C13.1969 4.66667 13.7056 4.45595 14.0807 4.08088C14.4558 3.70581 14.6665 3.1971 14.6665 2.66667V0.666667C14.6665 0.489856 14.5962 0.320286 14.4712 0.195262C14.3462 0.0702379 14.1766 0 13.9998 0C13.823 0 13.6534 0.0702379 13.5284 0.195262C13.4034 0.320286 13.3331 0.489856 13.3331 0.666667V2.04333C11.9682 0.82302 10.2258 0.108111 8.39705 0.0180684C6.56834 -0.0719742 4.76411 0.468305 3.28587 1.54862C1.80762 2.62894 0.744905 4.18386 0.275299 5.95354C-0.194308 7.72322 -0.0423553 9.60046 0.705764 11.2716C1.45388 12.9427 2.75285 14.3064 4.3856 15.1349C6.01836 15.9634 7.88599 16.2065 9.67641 15.8235C11.4668 15.4405 13.0716 14.4547 14.2225 13.0307C15.3734 11.6067 16.0008 9.83093 15.9998 8C15.9998 7.82319 15.9296 7.65362 15.8046 7.5286C15.6795 7.40357 15.51 7.33333 15.3331 7.33333Z",
              fill: "black"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M8.00016 4C7.82335 4 7.65378 4.07024 7.52876 4.19526C7.40373 4.32029 7.3335 4.48986 7.3335 4.66667V8C7.33353 8.1768 7.4038 8.34634 7.52883 8.47133L9.52883 10.4713C9.65456 10.5928 9.82297 10.66 9.99776 10.6584C10.1726 10.6569 10.3398 10.5868 10.4634 10.4632C10.587 10.3396 10.6571 10.1724 10.6586 9.9976C10.6601 9.8228 10.5929 9.6544 10.4715 9.52867L8.66683 7.724V4.66667C8.66683 4.48986 8.59659 4.32029 8.47157 4.19526C8.34654 4.07024 8.17697 4 8.00016 4Z",
              fill: "black"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_2753_2749" },
            child: [
              {
                tag: "rect",
                attr: { width: "16", height: "16", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 25287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ListContent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(622746);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ListContentWrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => {
  var _a, _b, _c, _d, _e, _f, _g;
  return [
    _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F,
    `
  background-color: ${(_a = props.theme) == null ? void 0 : _a.colors.white};
  ${props.padding ? `padding: ${props.padding}` : `padding: ${(_b = props.theme) == null ? void 0 : _b.spacing.s12} ${(_c = props.theme) == null ? void 0 : _c.spacing.s16}`};
  display: flex;
  align-items: center;
  position: relative;
 ${props.hasDivider ? ` &:after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: ${(_d = props.theme) == null ? void 0 : _d.spacing.s16};
      bottom: 0;
      left: ${(_e = props.theme) == null ? void 0 : _e.spacing.s16};
      border-bottom: ${(_f = props.theme) == null ? void 0 : _f.borderWeight.m} solid ${(_g = props.theme) == null ? void 0 : _g.colors.divider};
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }` : ``}
`
  ];
});
const LeftContent = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  flex: 1;
`;
const RightContent = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme }) => `
  text-align: right;
  margin-left: ${theme == null ? void 0 : theme.spacing.s12};
`);
const FocusText = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].span(({ theme }) => {
  return `
    color: ${theme == null ? void 0 : theme.colors.primary500};
  `;
});
const ListContent = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, {
    label,
    subText,
    subTextFocus,
    icon,
    extra,
    rightText,
    arrow,
    hasDivider = false,
    onClick
  } = _b, rest = __objRest(_b, [
    "label",
    "subText",
    "subTextFocus",
    "icon",
    "extra",
    "rightText",
    "arrow",
    "hasDivider",
    "onClick"
  ]);
  var _a2, _b2;
  const renderSubtext = () => {
    if (!subText && !subTextFocus)
      return null;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS, {
      color: "textSecondary",
      level: 1,
      line: 1
    }, subText && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, subText), subTextFocus && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FocusText, null, " ", subTextFocus));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListContentWrapper, __spreadValues({
    onClick: () => {
      if (onClick)
        onClick();
    },
    hasDivider,
    ref
  }, rest), icon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__/* .Shape */ .b, {
    marginRight: "s12"
  }, react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(icon, {
    size: !((_a2 = icon == null ? void 0 : icon.props) == null ? void 0 : _a2.size) ? 24 : (_b2 = icon == null ? void 0 : icon.props) == null ? void 0 : _b2.size
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LeftContent, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
    level: 1,
    line: 1
  }, label), renderSubtext()), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RightContent, null, rightText && !extra && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
    color: "textSecondary",
    level: 1,
    line: 1
  }, rightText), extra), arrow && !extra && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__/* .Shape */ .b, {
    marginLeft: "s8"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .ForwardOutlined */ .d, {
    size: 20
  })));
});
ListContent.displayName = "ListContent";




/***/ }),

/***/ 598227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ NavBar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(635412);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33188);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(751707);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(175915);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledNavBar = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  display: flex;
  height: 3.5rem;
  background: #fff;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08);
  &.detail {
    box-shadow: none;
  }
`;
const Center = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledSubTitle = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .SubTitle */ .DK)`
  ${(props) => props.line ? `text-overflow: ellipsis;` : ``}
`;
const Left = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div((props) => ({
  minWidth: "3.5rem",
  height: "3.5rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  visibility: props.visible ? "visible" : "hidden"
}));
const Right = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  min-width: 3.5rem;
  height: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledIcon = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .MoreInforOutlined */ .a)`
  display: block;
`;
const NavBar = (_a) => {
  var _b = _a, {
    title,
    goBack,
    right,
    toggleType = "click",
    dropdownMenu,
    isTitleMoreThan2Line = false,
    iconBack
  } = _b, props = __objRest(_b, [
    "title",
    "goBack",
    "right",
    "toggleType",
    "dropdownMenu",
    "isTitleMoreThan2Line",
    "iconBack"
  ]);
  const onlyTitle = !goBack && !right && !dropdownMenu;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledNavBar, __spreadValues({}, props), !onlyTitle && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Left, {
    visible: !!goBack
  }, iconBack || /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .ChevronLeftFilled */ .U, {
    size: 24,
    onClick: goBack,
    color: "#333"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Center, null, isTitleMoreThan2Line ? title : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSubTitle, {
    level: 2,
    line: 1
  }, title)), !onlyTitle && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Right, null, right, dropdownMenu && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Shape */ .b, {
    padding: "s8"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Dropdown */ .L, {
    trigger: toggleType,
    menu: dropdownMenu
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    size: 20,
    color: "#333"
  })))), !!_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_2__["default"].isAvailable() && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_head__WEBPACK_IMPORTED_MODULE_1___default()), null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title)));
};




/***/ }),

/***/ 862909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ NavBarDropdownMenu; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25287);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(792446);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(615819);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(734104);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(753954);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(247693);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(877936);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(803537);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(933104);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(186056);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(684443);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






const DropdownMenuWrapper = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__["default"].div(_templateObject());
const NavBarDropdownMenu = (param)=>{
    let { isShowingCategories =false , onClickHomeItem  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { setShowingCategory  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useCategories */ .L)();
    const { displayNewLayoutForProductDetailSGC  } = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DropdownMenuWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__/* .ListContent */ .y, {
                padding: "s8",
                label: displayNewLayoutForProductDetailSGC ? "Đi tới Trang chủ" : "Quay lại trang chủ",
                icon: displayNewLayoutForProductDetailSGC ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .HomePageOutlined */ .x, {
                    size: 16
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__/* .HomepageAlternativeOutlined */ .z, {}),
                onClick: ()=>{
                    router.push("/").then(()=>window.scrollTo(0, 0));
                    onClickHomeItem === null || onClickHomeItem === void 0 ? void 0 : onClickHomeItem();
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__/* .ListContent */ .y, {
                padding: "s8",
                label: "Sản phẩm vừa xem",
                icon: displayNewLayoutForProductDetailSGC ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_9__/* .TimeForwardOutlined */ .L, {
                    size: 16
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__/* .ClockAlternativeOutlined */ .I, {}),
                onClick: ()=>{
                    router.push("/san-pham-vua-xem").then(()=>window.scrollTo(0, 0));
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__/* .ListContent */ .y, {
                padding: "s8",
                label: "T\xecm kiếm",
                icon: displayNewLayoutForProductDetailSGC ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__/* .NewSearchOutlined */ .C, {
                    size: 16
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__/* .SearchOutlined */ .l, {}),
                onClick: ()=>{
                    router.push("/search").then(()=>window.scrollTo(0, 0));
                }
            }),
            isShowingCategories ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__/* .ListContent */ .y, {
                padding: "s8",
                label: "Danh mục sản phẩm",
                icon: displayNewLayoutForProductDetailSGC ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_13__/* .NewMoreProductOutlined */ .E, {
                    size: 16
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_14__/* .MoreProductOutlined */ .q, {}),
                onClick: ()=>{
                    setShowingCategory(true);
                }
            }) : null
        ]
    });
};


/***/ }),

/***/ 752627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ PageBuilderDesktop; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var components_HeadSection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(665207);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(626650);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127795);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





const PageBuilderDesktop = (props)=>{
    var ref;
    const { pbMetaData , name  } = props;
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_HeadSection__WEBPACK_IMPORTED_MODULE_2__/* .HeadSection */ .I, {
                title: pbMetaData.metaTitle || name,
                metaTitle: pbMetaData.metaTitle,
                description: pbMetaData.metaDescription,
                canonical: pbMetaData.canonical,
                noindex: pbMetaData.noIndex,
                keywords: (ref = pbMetaData.metaKeywords) === null || ref === void 0 ? void 0 : ref.join(","),
                image: pbMetaData.metaImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(contexts__WEBPACK_IMPORTED_MODULE_3__/* .HamperProvider */ .R, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page__WEBPACK_IMPORTED_MODULE_4__/* .PbPage */ .f, _objectSpreadProps(_objectSpread({}, props), {
                    page: query.slug
                }))
            })
        ]
    });
};


/***/ }),

/***/ 170919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PageBuilderDesktop": function() { return /* reexport */ PageBuilder/* PageBuilderDesktop */.K; },
  "PageBuilderMobile": function() { return /* reexport */ mobile_PageBuilder/* PageBuilderMobile */.B; },
  "PbPage": function() { return /* reexport */ page/* PbPage */.f; },
  "getMenuItems": function() { return /* reexport */ getMenuItems; },
  "getPbContentServerSideProps": function() { return /* reexport */ getPbContentServerSideProps; },
  "getPbLayout": function() { return /* reexport */ getPbLayout; },
  "getPbPageServerSideProps": function() { return /* reexport */ getPbPageServerSideProps; },
  "getProductsBySlug": function() { return /* reexport */ getProductsBySlug; },
  "getSSRData": function() { return /* reexport */ getSSRData; }
});

// EXTERNAL MODULE: ./modules/page-builder/page.tsx + 1 modules
var page = __webpack_require__(127795);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(775002);
// EXTERNAL MODULE: ./helpers/service-provider.ts + 20 modules
var service_provider = __webpack_require__(568915);
// EXTERNAL MODULE: ./helpers/menuItem.ts
var menuItem = __webpack_require__(101763);
// EXTERNAL MODULE: ./server/redis-client.ts
var redis_client = __webpack_require__(279106);
// EXTERNAL MODULE: ./modules/page-builder/service.ts + 1 modules
var service = __webpack_require__(137697);
;// CONCATENATED MODULE: ./modules/page-builder/getServerSideProps.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





const getPbPageServerSideProps = async function(context) {
    let page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "/";
    try {
        const epicEcom480 = context.req.tenantEnv.epicEcom480;
        const tempiWebsiteDomain = context.req.tenantEnv.tempiWebsiteDomain;
        var _host;
        const _ref = await getContent(context.req.tenantEnv, epicEcom480 ? tempiWebsiteDomain || "" : (_host = context.req.headers.host) !== null && _host !== void 0 ? _host : "", context.req.headers.host || "", page, epicEcom480 || false), { ssrData , metaData , content  } = _ref, config = _objectWithoutProperties(_ref, [
            "ssrData",
            "metaData",
            "content"
        ]);
        // check if 404 page
        const isNotFoundPage = !!content && Object.keys(content).some((key)=>key === "404");
        if (page !== "/" && isNotFoundPage) {
            return {
                notFound: true
            };
        }
        return {
            props: _objectSpreadProps(_objectSpread({}, config), {
                pbContent: content,
                pbSSRData: ssrData || {},
                pbMetaData: metaData
            })
        };
    } catch (e) {
        index_es/* logger.error */.k.error(e);
        return page !== "/" ? {
            /** define 404 for landing page */ notFound: true
        } : {
            props: {}
        };
    }
};
const getPbContentServerSideProps = async function(context) {
    let page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "/";
    try {
        const epicEcom480 = context.req.tenantEnv.epicEcom480;
        const showPbPagesFromWebsiteEditor = context.req.tenantEnv.showPbPagesFromWebsiteEditor;
        const tempiWebsiteDomain = context.req.tenantEnv.tempiWebsiteDomain;
        var _host;
        const _ref = await getContent(context.req.tenantEnv, epicEcom480 || showPbPagesFromWebsiteEditor ? tempiWebsiteDomain || "" : (_host = context.req.headers.host) !== null && _host !== void 0 ? _host : "", context.req.headers.host || "", page, epicEcom480 || showPbPagesFromWebsiteEditor || false), { ssrData , metaData , content  } = _ref, config = _objectWithoutProperties(_ref, [
            "ssrData",
            "metaData",
            "content"
        ]);
        return {
            props: _objectSpreadProps(_objectSpread({}, config), {
                pbContent: content,
                pbSSRData: ssrData || {},
                pbMetaData: metaData
            })
        };
    } catch (e) {
        index_es/* logger.error */.k.error(e);
        return page !== "/" ? {
            /** define 404 for landing page */ notFound: true
        } : {
            props: {}
        };
    }
};
const getContent = async function(tenantEnv, host, appliedDomain) {
    let page = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "/", isEpicEcom480 = arguments.length > 4 ? arguments[4] : void 0;
    const { isMobile  } = tenantEnv || {};
    const device = isMobile ? "mobile" : "desktop";
    /** get content */ const pbBuilder = new service/* PbService */.N(host, appliedDomain, isEpicEcom480);
    const { content , name ="" , extraInfo , canonical , menu =[] , layoutConfig ={} ,  } = await pbBuilder.getContentPage(page, device);
    /**get server-side by slot & slug|menu_zone */ const ssrInputs = await pbBuilder.getSSRInputs(_objectSpread({}, content, layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.header, layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.footer), device);
    const ssrData = await getSSRData(ssrInputs, tenantEnv);
    return {
        content,
        ssrData: ssrData || {},
        metaData: (0,dist_index_es.cleanObject)(_objectSpreadProps(_objectSpread({}, extraInfo), {
            canonical
        })) || null,
        name,
        menu
    };
};
const getPbLayout = async (isMobile, host, appliedDomain, isEpicEcom480)=>{
    const device = isMobile ? "mobile" : "desktop";
    /** get content */ const pbBuilder = new service/* PbService */.N(host, appliedDomain, isEpicEcom480);
    const { layoutConfig , menu , extraInfo  } = await pbBuilder.getLayoutPage(device);
    return {
        layoutConfig: layoutConfig,
        menu,
        extraInfo
    };
};
const getSSRData = async (ssrInputs, tenantEnv)=>{
    const { location , currentLanguage , terminalId  } = tenantEnv;
    const { discoveryService  } = new service_provider/* ServiceContainer */.h(tenantEnv);
    const fetchData = async (slot, params)=>{
        let data = {};
        switch(slot){
            case "mega_menu":
                var _menuZone;
                data = await getMenuItems(discoveryService, (_menuZone = params.menuZone) !== null && _menuZone !== void 0 ? _menuZone : "", terminalId, currentLanguage !== null && currentLanguage !== void 0 ? currentLanguage : "");
                break;
            default:
                data = await getProductsBySlug(tenantEnv, params.collectionSlug, location !== null && location !== void 0 ? location : "");
                break;
        }
        return {
            slot,
            serverData: data
        };
    };
    const outputs = await Promise.all(Object.entries(ssrInputs).map(async (param)=>{
        let [id, ssrInput] = param;
        const data = await Promise.all(ssrInput.map(async (input)=>{
            const { slot , collectionSlug , menuZone  } = input;
            return fetchData(slot, {
                collectionSlug,
                menuZone
            });
        }));
        return {
            [id]: data
        };
    }));
    // convert array => object :value
    const ssrOutputs = outputs.reduce((output, item)=>_objectSpread({}, output, item), {});
    return ssrOutputs;
};
const getMenuItems = async (discoveryService, menuZone, terminalId, currentLanguage)=>{
    try {
        const menuItems = await (0,redis_client/* fromRedisCache */.nr)(redis_client/* redisGroupKey.MENU_ITEMS */.aP.MENU_ITEMS, "".concat(terminalId, "_").concat(menuZone, "_").concat(currentLanguage), async ()=>{
            var ref;
            index_es/* logger.info */.k.info("get menuItems from discovery");
            const response = await discoveryService.getMenuItems(menuZone);
            return (0,menuItem/* buildTreeCategories */.Q)((response === null || response === void 0 ? void 0 : (ref = response.result) === null || ref === void 0 ? void 0 : ref.menuItems) || []);
        }, 7200000);
        return {
            menuItems
        };
    } catch (e) {
        index_es/* logger.error */.k.error(e);
        // error object could be anything
        // @ts-ignore
        return {
            menuItems: [],
            error: e.response
        };
    }
};
const getProductsBySlug = async function(tenantEnv, slug, location) {
    let limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 20, page = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1;
    try {
        var ref;
        const { discoveryServiceV2 , discoveryHelper  } = new service_provider/* ServiceContainer */.h(tenantEnv);
        // getting featureFlags
        const response = await discoveryServiceV2.search({
            slug,
            pageSize: limit,
            page
        });
        return (0,dist_index_es.cleanObject)({
            products: (response === null || response === void 0 ? void 0 : (ref = response.products) === null || ref === void 0 ? void 0 : ref.map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product))) || [],
            pagination: {
                totalItems: (response === null || response === void 0 ? void 0 : response.total) || 0,
                totalPages: Math.ceil(((response === null || response === void 0 ? void 0 : response.total) || 0) / (response.pageSize || limit))
            }
        });
    } catch (e) {
        index_es/* logger.error */.k.error(e);
        return {
            // response from DiscoveryService can be anything
            // @ts-ignore
            error: e.response || {},
            products: [],
            pagination: {
                totalItems: 0,
                totalPages: 1
            }
        };
    }
};

// EXTERNAL MODULE: ./modules/page-builder/desktop/PageBuilder.tsx
var PageBuilder = __webpack_require__(752627);
;// CONCATENATED MODULE: ./modules/page-builder/desktop/index.ts


// EXTERNAL MODULE: ./modules/page-builder/mobile/PageBuilder.tsx
var mobile_PageBuilder = __webpack_require__(184317);
;// CONCATENATED MODULE: ./modules/page-builder/mobile/index.ts


;// CONCATENATED MODULE: ./modules/page-builder/index.ts
/**
 * this module contains components, services and funtions that related to tempi
 * - tempi sdk
 * - build page by tempi sdk
 * - create customer tempi-sdk component
 */ 






/***/ }),

/***/ 184317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ PageBuilderMobile; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(598227);
/* harmony import */ var components_HeadSection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(665207);
/* harmony import */ var components_Layout_MobileLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(303094);
/* harmony import */ var components_mobile_organisms_NavBarDropdownMenu__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(862909);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(626650);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _page__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(127795);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









const PageBuilderMobile = (props)=>{
    var ref;
    const { pbMetaData , name  } = props;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout_MobileLayout__WEBPACK_IMPORTED_MODULE_3__/* .MobileLayout */ .n, {
        navbar: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__/* .NavBar */ .l, {
            title: name,
            goBack: ()=>{
                router.back();
            },
            dropdownMenu: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_mobile_organisms_NavBarDropdownMenu__WEBPACK_IMPORTED_MODULE_5__/* .NavBarDropdownMenu */ .o, {})
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_HeadSection__WEBPACK_IMPORTED_MODULE_6__/* .HeadSection */ .I, {
                title: pbMetaData.metaTitle || name,
                metaTitle: pbMetaData.metaTitle,
                description: pbMetaData.metaDescription,
                canonical: pbMetaData.canonical,
                noindex: pbMetaData.noIndex,
                keywords: (ref = pbMetaData.metaKeywords) === null || ref === void 0 ? void 0 : ref.join(","),
                image: pbMetaData.metaImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(contexts__WEBPACK_IMPORTED_MODULE_7__/* .HamperProvider */ .R, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page__WEBPACK_IMPORTED_MODULE_8__/* .PbPage */ .f, _objectSpreadProps(_objectSpread({}, props), {
                    page: router.query.slug
                }))
            })
        ]
    });
};


/***/ }),

/***/ 279106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aP": function() { return /* binding */ redisGroupKey; },
/* harmony export */   "gs": function() { return /* binding */ REDIS_DEFAULT_EXPIRED; },
/* harmony export */   "nr": function() { return /* binding */ fromRedisCache; }
/* harmony export */ });
/* unused harmony exports REDIS_DEFAULT_TIMEOUT, RedisInstance, promiseTimeout */
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(420577);
/* harmony import */ var redis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(958859);
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77335);
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(util__WEBPACK_IMPORTED_MODULE_2__);
/* provided dependency */ var process = __webpack_require__(960387);



const redisGroupKey = {
    SELLER: "SELLER",
    MASTER_CAT: "MASTER_CAT",
    CRON_JOB: "CRON_JOB",
    SELLER_CAT: "SELLER_CAT",
    MAPPING_SELLER_CAT_PRODUCTS: "MAPPING_SELLER_CAT_PRODUCTS",
    MENU_ITEMS: "MENU_ITEMS",
    SITEMAP: "SITEMAP",
    COLLECTIONS: "COLLECTIONS",
    CATEGORIES: "CATEGORIES",
    ARTICLES: "ARTICLES",
    PRODUCTS_CATEGORY: "PRODUCTS_CATEGORY",
    PRODUCTS_COLLECTION: "PRODUCTS_COLLECTION",
    PRODUCTS: "PRODUCTS",
    LANDING: "LANDING",
    LAYOUT: "LAYOUT",
    BREADCRUMB: "BREADCRUMB",
    FEATURE_FLAG: "FEATURE_FLAG",
    FIXED_PRODUCT_VARIANTS: "FIXED_PRODUCT_VARIANTS"
};
const REDIS_DEFAULT_TIMEOUT = 3000;
const REDIS_DEFAULT_EXPIRED = 24 * 60 * 60; // 1 day
class RedisInstance {
    static getInstance() {
        if (!this.redisInstance) {
            this.redisInstance = new RedisInstance();
        }
        return this.redisInstance;
    }
    asyncFn(fn) {
        return (0,util__WEBPACK_IMPORTED_MODULE_2__.promisify)(fn).bind(this.redisClient);
    }
    getInstance() {
        return this.redisClient;
    }
    computeKeyName(group, key) {
        if (!redisGroupKey[group]) return null;
        return "".concat(redisGroupKey[group], ":").concat(key);
    }
    // default redis key is computed as group:key
    setValue(group, key, value) {
        let timeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : REDIS_DEFAULT_TIMEOUT, expired = arguments.length > 4 ? arguments[4] : void 0;
        const computedKey = this.computeKeyName(group, key);
        if (!computedKey) return null;
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.info */ .k.info("redis:set:".concat(computedKey));
        const args = expired ? [
            computedKey,
            value,
            "EX",
            expired
        ] : [
            computedKey,
            value
        ];
        return promiseTimeout(this.asyncFn(this.redisClient.set)(...args), timeout);
    }
    msetValue(group, keyValues) {
        let timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : REDIS_DEFAULT_TIMEOUT, expired = arguments.length > 3 ? arguments[3] : void 0, logId = arguments.length > 4 ? arguments[4] : void 0;
        let args = [];
        Object.entries(keyValues).forEach((param)=>{
            let [key, value] = param;
            const computedKey = this.computeKeyName(group, key);
            if (computedKey) {
                args = [
                    ...args,
                    computedKey,
                    value
                ];
            }
        });
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.info */ .k.info("".concat(logId ? "[".concat(logId, "] ") : "", "redis:mset:").concat(args.map((arg, index)=>index % 2 === 0 && arg).filter((arg)=>!!arg)));
        if (expired) {
            args = [
                ...args,
                "EX",
                expired.toString()
            ];
        }
        return promiseTimeout(this.asyncFn(this.redisClient.mset)(...args), timeout, logId);
    }
    deleteValueByKeys(keys) {
        let timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : REDIS_DEFAULT_TIMEOUT;
        if (keys.length < 1) return new Promise((resolve)=>resolve(null));
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.info */ .k.info("redis:del:".concat(keys));
        return promiseTimeout(this.asyncFn(this.redisClient.del)(...keys), timeout);
    }
    getValue(group, key) {
        let timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : REDIS_DEFAULT_TIMEOUT;
        const computedKey = this.computeKeyName(group, key);
        if (!computedKey) return null;
        return promiseTimeout(this.asyncFn(this.redisClient.get)(computedKey), timeout);
    }
    mgetValue(group, keys) {
        let timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : REDIS_DEFAULT_TIMEOUT;
        const computedKeys = keys.map((key)=>this.computeKeyName(group, key)).filter((key)=>!!key);
        if (computedKeys.length < 1) return new Promise((resolve)=>resolve([]));
        return promiseTimeout(this.asyncFn(this.redisClient.mget)(...computedKeys), timeout);
    }
    hashSetValue(group, keyValue) {
        let timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : REDIS_DEFAULT_TIMEOUT;
        if (!redisGroupKey[group]) return null;
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.info */ .k.info("redis:hmset:".concat(redisGroupKey[group], ":").concat(Object.keys(keyValue).join(",")));
        return promiseTimeout(this.asyncFn(this.redisClient.hmset)(redisGroupKey[group], keyValue), timeout);
    }
    hashGetValue(group, key) {
        let timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : REDIS_DEFAULT_TIMEOUT;
        if (!redisGroupKey[group]) return null;
        return promiseTimeout(this.asyncFn(this.redisClient.hget)(redisGroupKey[group], key), timeout);
    }
    getKeysByPattern(pattern) {
        let timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : REDIS_DEFAULT_TIMEOUT;
        return promiseTimeout(this.asyncFn(this.redisClient.keys)(pattern), timeout);
    }
    constructor(){
        this.redisClient = redis__WEBPACK_IMPORTED_MODULE_1__.createClient({
            host: process.env.REDIS_HOST,
            port: process.env.REDIS_PORT ? Number(process.env.REDIS_PORT) : 6379,
            db: process.env.REDIS_DB ? Number(process.env.REDIS_DB) : 0,
            retry_strategy: (options)=>{
                if (options.attempt > 4) return new Error("Redis server refused the connection");
                // reconnect after 1 minutes
                return 60000;
            }
        });
        this.redisClient.on("error", _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error);
    }
}
/**
 * This function is only called in server
 */ const fromRedisCache = async function(groupKey, key, getData) {
    let expiredTime = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : REDIS_DEFAULT_EXPIRED, noCache = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    const redisInstance = RedisInstance.getInstance();
    const fetchData = async ()=>{
        return getData().then((result)=>{
            try {
                if (Array.isArray(result) && result.length > 0 || !Array.isArray(result) && result) {
                    redisInstance.setValue(groupKey, key, JSON.stringify(result), REDIS_DEFAULT_TIMEOUT, expiredTime);
                }
            } finally{
                return result;
            }
        });
    };
    try {
        const cacheData = await redisInstance.getValue(groupKey, key);
        return cacheData && !noCache ? JSON.parse(cacheData) : fetchData();
    } catch (e) {
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error(e);
        return fetchData();
    }
};

/**
 *
 * @param promise
 * @param timeout: in milliseconds
 */ const promiseTimeout = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
promise, timeoutMillis, logId)=>{
    let timeoutFn;
    return Promise.race([
        promise,
        new Promise((_, reject)=>{
            timeoutFn = setTimeout(()=>{
                const errorMessage = "".concat(logId ? "[".concat(logId, "] ") : "", "Time limit exceeded ").concat(timeoutMillis, "ms");
                _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error(errorMessage);
                reject(new Error(errorMessage));
            }, timeoutMillis);
        }), 
    ]).then((v)=>{
        clearTimeout(timeoutFn);
        return v;
    }).catch((err)=>{
        clearTimeout(timeoutFn);
        throw err;
    });
};


/***/ }),

/***/ 106980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ canUseDom; }
/* harmony export */ });
function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

/***/ }),

/***/ 514796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ wrapperRaf; }
/* harmony export */ });
var raf = function raf(callback) {
  return +setTimeout(callback, 16);
};

var caf = function caf(num) {
  return clearTimeout(num);
};

if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
  raf = function raf(callback) {
    return window.requestAnimationFrame(callback);
  };

  caf = function caf(handle) {
    return window.cancelAnimationFrame(handle);
  };
}

var rafUUID = 0;
var rafIds = new Map();

function cleanup(id) {
  rafIds.delete(id);
}

function wrapperRaf(callback) {
  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;

  function callRef(leftTimes) {
    if (leftTimes === 0) {
      // Clean up
      cleanup(id); // Trigger

      callback();
    } else {
      // Next raf
      var realId = raf(function () {
        callRef(leftTimes - 1);
      }); // Bind real raf id

      rafIds.set(id, realId);
    }
  }

  callRef(times);
  return id;
}

wrapperRaf.cancel = function (id) {
  var realId = rafIds.get(id);
  cleanup(realId);
  return caf(realId);
};

/***/ }),

/***/ 26515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mH": function() { return /* binding */ fillRef; },
/* harmony export */   "sQ": function() { return /* binding */ composeRef; }
/* harmony export */ });
/* unused harmony export supportRef */
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12129);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(552744);


function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}
/**
 * Merge refs into one ref function to support ref passing.
 */

function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
}
function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;

  var type = isMemo(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type; // Function component node

  if (typeof type === 'function' && !((_type$prototype = type.prototype) === null || _type$prototype === void 0 ? void 0 : _type$prototype.render)) {
    return false;
  } // Class component


  if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) === null || _nodeOrComponent$prot === void 0 ? void 0 : _nodeOrComponent$prot.render)) {
    return false;
  }

  return true;
}
/* eslint-enable */

/***/ }),

/***/ 562333:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 902134:
/***/ (function() {

/* (ignored) */

/***/ })

}]);